import { Directive } from '@angular/core'
import { NgClass, NgStyle } from '@angular/common'

@Directive({
  selector: '[icos-main]',
  providers: [NgClass, NgStyle],
  host: { class: 'icos-main' },
})
export class IcosMainDirective {

}
